module.exports = __webpack_public_path__ + "img/fangan1.74b0169b.png";